import { KeyboardBackspace } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useNavigate } from "react-router-dom"

const Backbutton = ({ onClick }) => {
    const navigate = useNavigate();

    return (
        <IconButton sx={{ fontSize: 12 }} onClick={() => onClick()}>
            <KeyboardBackspace /> back
        </IconButton>
    )
}
export default Backbutton